import FundPortfolio from './FundPortfolio'

export default FundPortfolio
